// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".astrology-card[data-v-b891eb4c]{background:linear-gradient(180deg,#181819 40%,rgba(46,34,112,.5));width:calc(50% - 16px);aspect-ratio:164/212}@media (min-width:640px){.astrology-card[data-v-b891eb4c]{width:164px;height:212px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
